/*
 * TFO: per-variant product media from image filenames (replaces Variant Wizard).
 * Server side: snippets/tfo-variant-media.liquid renders the initial state and a JSON map
 * { media: { <media id>: "<sku>" | "" } } into the product gallery ("" = shared image).
 *
 * On variant:change (capture phase on document, so before Warehouse's handler on the section):
 * - cells get data-group-name="tfo-media", which makes Warehouse rebuild the carousel; no product
 *   option is named like that, so Warehouse leaves our classes alone;
 * - the is-filtered classes are swapped in a requestAnimationFrame callback. It is registered
 *   before Warehouse's own (fastdom) frame callback, so both run in the same frame: the cells we
 *   un-filter sit outside the carousel until Warehouse re-activates it, and must never be laid
 *   out in that state (on mobile they briefly pushed the page down by their full height).
 * Works for the product page, featured product and quick view.
 */
(function () {
  function findData(target) {
    for (var el = target; el && el !== document; el = el.parentElement) {
      var data = el.querySelector && el.querySelector('script[data-tfo-variant-media]');
      if (data) return data;
    }
    return null;
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    var data = variant && findData(event.target);
    if (!data) return;

    var parsed;
    try {
      parsed = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    var map = parsed.media;

    var sku = (variant.sku || '').toLowerCase();
    var ids = Object.keys(map);
    var own = ids.filter(function (id) { return map[id] !== '' && map[id] === sku; });
    var shared = ids.filter(function (id) { return map[id] === ''; });
    var visible;
    if (!sku && parsed.first && parsed.first in map) {
      visible = [parsed.first]; // variant without SKU (sold High End article): cover only
    } else {
      visible = own.length ? own : shared.length ? shared : ids;
    }

    var gallery = data.closest('.product-gallery') || data.parentElement;
    var cells = gallery.querySelectorAll('[data-media-id]');

    cells.forEach(function (el) {
      if (el.classList.contains('product-gallery__carousel-item') && !el.hasAttribute('data-group-name')) {
        el.setAttribute('data-group-name', 'tfo-media');
      }
    });

    requestAnimationFrame(function () {
      cells.forEach(function (el) {
        var id = el.getAttribute('data-media-id');
        if (id in map) el.classList.toggle('is-filtered', visible.indexOf(id) === -1);
      });
    });
  }, true);
})();
